var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCloseIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 17.4L11.1 22.3C10.9167 22.4833 10.6833 22.575 10.4 22.575C10.1167 22.575 9.88333 22.4833 9.7 22.3C9.51667 22.1167 9.425 21.8833 9.425 21.6C9.425 21.3167 9.51667 21.0833 9.7 20.9L14.6 16L9.7 11.1C9.51667 10.9167 9.425 10.6833 9.425 10.4C9.425 10.1167 9.51667 9.88333 9.7 9.7C9.88333 9.51667 10.1167 9.425 10.4 9.425C10.6833 9.425 10.9167 9.51667 11.1 9.7L16 14.6L20.9 9.7C21.0833 9.51667 21.3167 9.425 21.6 9.425C21.8833 9.425 22.1167 9.51667 22.3 9.7C22.4833 9.88333 22.575 10.1167 22.575 10.4C22.575 10.6833 22.4833 10.9167 22.3 11.1L17.4 16L22.3 20.9C22.4833 21.0833 22.575 21.3167 22.575 21.6C22.575 21.8833 22.4833 22.1167 22.3 22.3C22.1167 22.4833 21.8833 22.575 21.6 22.575C21.3167 22.575 21.0833 22.4833 20.9 22.3L16 17.4Z",
    fill: "#474747",
    fillOpacity: 0.8
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCloseIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/closeIcon.64030f2888b90c26c5b04e450382e206.svg";